<template>
    <div
      ref="menuConent"
      class="menuConent"
    >
    <div class="home-con home-con-big">
        <div ref="homeBar" :class="searchFixed?'fixed':''" class="home-bar">
          <div class="home-bar-box">
            <label style="position: relative;" v-for="(item,index) in labelList" :key='index' :class="{active: active === index}" :for=item.forName @click="changeType(index)">
                <img class="label-img" :src=item.imgSrc>
                <p class="label-tit">{{item.title}}</p>
            </label>
          </div>
        </div>
        <div ref="homeBarCon" id="radio">
          <input id="first" type="radio" name="tab" checked>
          <div class="target-div">
            <div class="home-con-big-title">更为强大的全渠道获客能力</div>
            <div class="home-con-item home-con-item-middle">
              <div class="first-word">
                <div class="first-word-big">
                  线上展厅
                </div>
                <div class="first-word-middle">千人千面的线上内容门户集合</div>
                <div class="first-word-small">
                  <div class="first-word-small-item first-word-small1">
                    更懂用户使用习惯和需求，实现品牌价值的极致展示
                  </div>
                  <div class="first-word-small-item first-word-small2">
                    支持组件化配置，快速配置出不同城市首页及项目详情页
                  </div>
                  <div class="first-word-small-item first-word-small2">
                    销售工作台11种拓客物料，覆盖拓客全场景
                  </div>
                </div>
                <div class="min-phone-tab-img-box">
                  <img class="first-img" src="https://cdn.ideamake.cn/sw-pc/images/customer-acquisition-one.png" alt="">
                </div>
                <div class="first-word-big-button" @click="information('客户获取-线上展厅')" data-agl-cvt="5">免费试用</div>
              </div>
              <div class="tab-img-box">
                <img class="first-img" src="https://cdn.ideamake.cn/sw-pc/images/customer-acquisition-one.png" alt="">
              </div>
            </div>
            <div class="home-con-item home-con-item-big">
              <div class="tab-img-box">
                <img class="first-img" src="https://cdn.ideamake.cn/sw-pc/images/customer-acquisition-two.png" alt="">
              </div>
              <div class="first-word">
                <div class="first-word-big">
                  投放引流
                </div>
                <div class="first-word-middle">投放获客的一站式提效解决方案</div>
                <div class="first-word-small">
                  <div class="first-word-small-item first-word-small1">
                    主流媒体投放平台全覆盖，打通公域往私域获客导流通路
                  </div>
                  <div class="first-word-small-item first-word-small2">
                    线索统一收口，一站式管理所有客源
                  </div>
                  <div class="first-word-small-item first-word-small2">
                    投放效果分析，提高精准投放效率，优化投放模型，提高长期费效
                  </div>
                </div>
                <div class="min-phone-tab-img-box">
                  <img class="first-img" src="https://cdn.ideamake.cn/sw-pc/images/customer-acquisition-two.png" alt="">
                </div>
                <div class="first-word-big-button" @click="information('客户获取-投放引流')" data-agl-cvt="5">免费试用</div>
              </div>
            </div>
            <div class="home-con-item home-con-item-big">
              <div class="first-word">
                <div class="first-word-big">
                  活动裂变
                </div>
                <div class="first-word-middle">优秀活动一键复用，玩法多样快速组合</div>
                <div class="first-word-small">
                  <div class="first-word-small-item first-word-small1">
                    提供多种活动模版，涵盖入市、开盘、续销等营销期和不同节日场景
                  </div>
                  <div class="first-word-small-item first-word-small2">
                    常规活动1-3天快速上线，复杂版2周内定制完成，提升上线效率
                  </div>
                  <div class="first-word-small-item first-word-small2">
                    组队、助力、签到等多种玩法，实现吸粉留资，解决常见营销命题
                  </div>
                  <div class="first-word-small-item first-word-small2">
                    优秀案例一键高效复用，摆脱大型互动每次开发的模式
                  </div>
                </div>
                <div class="min-phone-tab-img-box">
                  <img class="first-img" src="https://cdn.ideamake.cn/sw-pc/images/customer-acquisition-three.png" alt="">
                </div>
                <div class="first-word-big-button" @click="information('客户获取-活动裂变')" data-agl-cvt="5">免费试用</div>
              </div>
              <div class="tab-img-box">
                <img class="first-img" src="https://cdn.ideamake.cn/sw-pc/images/customer-acquisition-three.png" alt="">
              </div>
            </div>
            <div class="home-con-item home-con-item-big">
              <div class="tab-img-box">
                <img class="first-img" src="https://cdn.ideamake.cn/sw-pc/images/customer-acquisition-four.png" alt="">
              </div>
              <div class="first-word">
                <div class="first-word-big">
                  全民营销
                </div>
                <div class="first-word-middle">扩大营销群体通路，实现低成本获客转化</div>
                <div class="first-word-small">
                  <div class="first-word-small-item first-word-small1">
                    一键注册，快速招募经纪人
                  </div>
                  <div class="first-word-small-item first-word-small2">
                    物料获客，自动报备
                  </div>
                  <div class="first-word-small-item first-word-small2">
                    多种类过程激励，降低门槛刺激持续推客
                  </div>
                  <div class="first-word-small-item first-word-small2">
                    自动算佣，极速结佣
                  </div>
                </div>
                <div class="min-phone-tab-img-box">
                  <img class="first-img" src="https://cdn.ideamake.cn/sw-pc/images/customer-acquisition-four.png" alt="">
                </div>
                <div class="first-word-big-button" @click="information('客户获取-全民营销')" data-agl-cvt="5">免费试用</div>
              </div>
            </div>
            <div class="home-con-item home-con-item-big">
              <div class="first-word">
                <div class="first-word-big">
                  云创平台
                </div>
                <div class="first-word-middle">一站式营销物料生产平台</div>
                <div class="first-word-small">
                  <div class="first-word-small-item first-word-small1">
                    可视化开发平台，聚焦内容创意，集成流程一目了然
                  </div>
                  <div class="first-word-small-item first-word-small2">
                    海量优秀案例模板，覆盖多类型地产应用场景
                  </div>
                  <div class="first-word-small-item first-word-small2">
                    跨平台应用技术，满足平板、大屏、移动端、一体机多平台内容制作
                  </div>
                  <div class="first-word-small-item first-word-small2">
                    八大内容模块，满足不同营销节点推广需求
                  </div>
                </div>
                <div class="min-phone-tab-img-box">
                  <img class="first-img" src="https://cdn.ideamake.cn/sw-pc/images/customer-acquisition-five.png" alt="">
                </div>
                <div class="first-word-big-button" @click="information('客户获取-云创平台')" data-agl-cvt="5">免费试用</div>
              </div>
              <div class="tab-img-box">
                <img class="first-img" src="https://cdn.ideamake.cn/sw-pc/images/customer-acquisition-five.png" alt="">
              </div>
            </div>
          </div>
          <input id="second" type="radio" name="tab">
          <div class="target-div">
            <div class="home-con-big-title">精准洞察与精细运营，实现用户价值最大化</div>
            <div class="home-con-item home-con-item-middle">
              <div class="first-word">
                <div class="first-word-big">
                  线索管理
                </div>
                <div class="first-word-middle">集中自动化分客及运营管理</div>
                <div class="first-word-small">
                  <div class="first-word-small-item first-word-small1">
                    定向圈选客群，场景化规则配置，线索实时自动分配
                  </div>
                  <div class="first-word-small-item first-word-small2">
                    跟进效果智能判定，错配线索自动回流，低质量线索废弃处理
                  </div>
                  <div class="first-word-small-item first-word-small2">
                    多种分配模式，根据顺序、人力、能力等模型匹配客户资源
                  </div>
                  <div class="first-word-small-item first-word-small2">
                    客户台账，基于100+属性细分客户，实现分层运营
                  </div>
                </div>
                <div class="min-phone-tab-img-box">
                  <img class="first-img" src="https://cdn.ideamake.cn/sw-pc/images/customer-operations-one.png" alt="">
                </div>
                <div class="first-word-big-button" @click="information('客户运营-线索管理')" data-agl-cvt="5">免费试用</div>
              </div>
              <div class="tab-img-box">
                <img class="first-img" src="https://cdn.ideamake.cn/sw-pc/images/customer-operations-one.png" alt="">
              </div>
            </div>
            <div class="home-con-item home-con-item-big">
              <div class="tab-img-box">
                <img style="height: 503px;" class="first-img" src="https://cdn.ideamake.cn/sw-pc/images/customer-operations-two.png" alt="">
              </div>
              <div class="first-word">
                <div class="first-word-big">
                  意向识别
                </div>
                <div class="first-word-middle">精准识别客户意向，辅助营销决策</div>
                <div class="first-word-small">
                  <div class="first-word-small-item first-word-small1">
                    基于任务系统+AI云Call，智能快捷识别线索意向
                  </div>
                  <div class="first-word-small-item first-word-small2">
                    洞悉客群属性和行为，精准预测客户生命周期阶段
                  </div>
                  <div class="first-word-small-item first-word-small2">
                    基于全渠道数据埋点，生成360度描摹，还原客户真实画像
                  </div>
                </div>
                <div class="min-phone-tab-img-box">
                  <img class="first-img" src="https://cdn.ideamake.cn/sw-pc/images/customer-operations-two.png" alt="">
                </div>
                <div class="first-word-big-button" @click="information('客户运营-意向识别')" data-agl-cvt="5">免费试用</div>
              </div>
            </div>
            <div class="home-con-item home-con-item-big">
              <div class="first-word">
                <div class="first-word-big">
                  自动化营销
                </div>
                <div class="first-word-middle">基于用户行为洞察的智能运营</div>
                <div class="first-word-small">
                  <div class="first-word-small-item first-word-small1">
                    结合用户生命周期节点、用户POI，实现定向差异化运营
                  </div>
                  <div class="first-word-small-item first-word-small2">
                    支持以短信、服务号、企微自动化触达客户，实现关键场景自动牵引
                  </div>
                  <div class="first-word-small-item first-word-small2">
                    丰富的运营计划模板，赋能多角色，快速复用实现运营提效
                  </div>
                </div>
                <div class="min-phone-tab-img-box">
                  <img class="first-img" src="https://cdn.ideamake.cn/sw-pc/images/customer-operations-three.png" alt="">
                </div>
                <div class="first-word-big-button" @click="information('客户运营-自动化营销')" data-agl-cvt="5">免费试用</div>
              </div>
              <div class="tab-img-box">
                <img class="first-img" src="https://cdn.ideamake.cn/sw-pc/images/customer-operations-three.png" alt="">
              </div>
            </div>
            <div class="home-con-item home-con-item-big">
              <div class="tab-img-box">
                <img style="height: 479px;" class="first-img" src="https://cdn.ideamake.cn/sw-pc/images/customer-operations-four.png" alt="">
              </div>
              <div class="first-word">
                <div class="first-word-big">
                  企微运营
                </div>
                <div class="first-word-middle">标准化线上服务流程，提高客户成交转化率</div>
                <div class="first-word-small">
                  <div class="first-word-small-item first-word-small1">
                    一客一群，客户需求及时响应，实现自动化的跟进和标签管理
                  </div>
                  <div class="first-word-small-item first-word-small2">
                    基于客户标签，信息按需分配，专属内容一键群发
                  </div>
                  <div class="first-word-small-item first-word-small2">
                    丰富拓客工具，提高平台曝光度
                  </div>
                  <div class="first-word-small-item first-word-small2">
                    服务过程管控，提升组织整体服务质量与效率
                  </div>
                </div>
                <div class="min-phone-tab-img-box">
                  <img class="first-img" src="https://cdn.ideamake.cn/sw-pc/images/customer-operations-four.png" alt="">
                </div>
                <div class="first-word-big-button" @click="information('客户运营-企微运营')" data-agl-cvt="5">免费试用</div>
              </div>
            </div>
          </div>
          <input id="third" type="radio" name="tab">
          <div class="target-div">
            <div class="home-con-big-title">案场管理服务流程标准化，实现传统案场业务升级</div>
            <div class="home-con-item home-con-item-middle">
              <div class="first-word">
                <div class="first-word-big">
                  全渠道判客
                </div>
                <div class="first-word-middle">更为灵活的判客机制，支持弱关系营销</div>
                <div class="first-word-small">
                  <div class="first-word-small-item first-word-small1">
                    多种签到方式满足案场各类场景，提升案场效率
                  </div>
                  <div class="first-word-small-item first-word-small2">
                    自动判客，客户溯源，快速完成案场判客确客流程
                  </div>
                  <div class="first-word-small-item first-word-small2">
                    优先判客，打通拓客来源与判客，实现利益与顾问直接挂钩
                  </div>
                </div>
                <div class="min-phone-tab-img-box">
                  <img class="first-img" src="https://cdn.ideamake.cn/sw-pc/images/case-management-one.png" alt="">
                </div>
                <div class="first-word-big-button" @click="information('案场管理-全渠道判客')" data-agl-cvt="5">免费试用</div>
              </div>
              <div class="tab-img-box">
                <img class="first-img" src="https://cdn.ideamake.cn/sw-pc/images/case-management-one.png" alt="">
              </div>
            </div>
            <div class="home-con-item home-con-item-big">
              <div class="tab-img-box">
                <img class="first-img" src="https://cdn.ideamake.cn/sw-pc/images/case-management-two.png" alt="">
              </div>
              <div class="first-word">
                <div class="first-word-big">
                  智能工牌
                </div>
                <div class="first-word-middle">一线销讲看得到，案场盘客更高效</div>
                <div class="first-word-small">
                  <div class="first-word-small-item first-word-small1">
                    还原更真实客户画像，盘客更高效
                  </div>
                  <div class="first-word-small-item first-word-small2">
                    复制销冠能力模型，让优秀销售经验充分流淌
                  </div>
                  <div class="first-word-small-item first-word-small2">
                    总结分析客户关注点和敏感点，销讲策略迭代升级
                  </div>
                  <div class="first-word-small-item first-word-small2">
                    自动匹配用户，开机即用流畅体验，极大提升录音覆盖率
                  </div>
                </div>
                <div class="min-phone-tab-img-box">
                  <img class="first-img" src="https://cdn.ideamake.cn/sw-pc/images/case-management-two.png" alt="">
                </div>
                <div class="first-word-big-button" @click="information('案场管理-智能工牌')" data-agl-cvt="5">免费试用</div>
              </div>
            </div>
            <div class="home-con-item home-con-item-big">
              <div class="first-word">
                <div class="first-word-big">
                  交易管理
                </div>
                <div class="first-word-middle">线上完成购房全动作，在家也能轻松购房</div>
                <div class="first-word-small">
                  <div class="first-word-small-item first-word-small1">
                    支持录入交易、在线交易、销售系统对接交易，适应各场景交易流程，更加便捷高效
                  </div>
                  <div class="first-word-small-item first-word-small2">
                    在线认筹、认购、开盘等交易节点数字化管理，交易单更新更加及时，省去人工录入成本
                  </div>
                  <div class="first-word-small-item first-word-small2">
                    跟踪每日交易情况，快捷查看交易信息
                  </div>
                </div>
                <div class="min-phone-tab-img-box">
                  <img class="first-img" src="https://cdn.ideamake.cn/sw-pc/images/case-management-three.png" alt="">
                </div>
                <div class="first-word-big-button" @click="information('案场管理-交易管理')" data-agl-cvt="5">免费试用</div>
              </div>
              <div class="tab-img-box">
                <img class="first-img" src="https://cdn.ideamake.cn/sw-pc/images/case-management-three.png" alt="">
              </div>
            </div>
            <div class="home-con-item home-con-item-big">
              <div class="tab-img-box">
                <img class="first-img" src="https://cdn.ideamake.cn/sw-pc/images/case-management-four.png" alt="">
              </div>
              <div class="first-word">
                <div class="first-word-big">
                  风险管控
                </div>
                <div class="first-word-middle">多重核验预警提示，守好每一道飞单防线</div>
                <div class="first-word-small">
                  <div class="first-word-small-item first-word-small1">
                    通过推荐、成交等全流程数据，实现8大风险类型校验
                  </div>
                  <div class="first-word-small-item first-word-small2">
                    客户到访过程及轨迹全程记录，精准判别风险
                  </div>
                </div>
                <div class="min-phone-tab-img-box">
                  <img class="first-img" src="https://cdn.ideamake.cn/sw-pc/images/case-management-four.png" alt="">
                </div>
                <div class="first-word-big-button" @click="information('案场管理-风险管控')" data-agl-cvt="5">免费试用</div>
              </div>
            </div>
            <div class="home-con-item home-con-item-big">
              <div class="first-word">
                <div class="first-word-big">
                  佣金管理
                </div>
                <div class="first-word-middle">针对多角色的佣金灵活组合方案</div>
                <div class="first-word-small">
                  <div class="first-word-small-item first-word-small1">
                    支持针对不同身份，不同物业类型，不同计算规则配置佣金方案
                  </div>
                  <div class="first-word-small-item first-word-small2">
                    支持下线客户成交的分佣方案进行成交奖励计算
                  </div>
                  <div class="first-word-small-item first-word-small2">
                    支持配置佣金、积分或线下定制服务的多样化奖励
                  </div>
                </div>
                <div class="min-phone-tab-img-box">
                  <img class="first-img" src="https://cdn.ideamake.cn/sw-pc/images/case-management-five.png" alt="">
                </div>
                <div class="first-word-big-button" @click="information('案场管理-佣金管理')" data-agl-cvt="5">免费试用</div>
              </div>
              <div class="tab-img-box">
                <img style="height: 500px;" class="first-img" src="https://cdn.ideamake.cn/sw-pc/images/case-management-five.png" alt="">
              </div>
            </div>
          </div>
          <input id="four" type="radio" name="tab">
          <div class="target-div">
            <div class="home-con-big-title">行业唯一的营销BI，真正的数据洞察</div>
            <div class="home-con-item home-con-item-middle">
              <div class="first-word">
                <div class="first-word-big">
                  BI看板
                </div>
                <div class="first-word-middle">为一线提供真实业务指导意义的营销BI</div>
                <div class="first-word-small">
                  <div class="first-word-small-item first-word-small1">
                    集成全域数据，打造1+3可视化分析平台，支撑营销决策
                  </div>
                  <div class="first-word-small-item first-word-small2">
                    数据联动过滤及下钻，分析系统性强
                  </div>
                  <div class="first-word-small-item first-word-small2">
                    一次建模，长期复用，数据处理效率大大提升
                  </div>
                  <div class="first-word-small-item first-word-small2">
                    满足团队协作、项目管理、数据协作等多重场景
                  </div>
                </div>
                <div class="min-phone-tab-img-box">
                  <img class="first-img" src="https://cdn.ideamake.cn/sw-pc/images/data-enabling-one.png" alt="">
                </div>
                <div class="first-word-big-button" @click="information('数据赋能-BI看板')" data-agl-cvt="5">免费试用</div>
              </div>
              <div class="tab-img-box">
                <img class="first-img" src="https://cdn.ideamake.cn/sw-pc/images/data-enabling-one.png" alt="">
              </div>
            </div>
            <div class="home-con-item home-con-item-big">
              <div class="tab-img-box">
                <img class="first-img" src="https://cdn.ideamake.cn/sw-pc/images/data-enabling-two.png" alt="">
              </div>
              <div class="first-word">
                <div class="first-word-big">
                  客户分析平台
                </div>
                <div class="first-word-middle">深入业务场景的一站式用户行为分析平台</div>
                <div class="first-word-small">
                  <div class="first-word-small-item first-word-small1">
                    打通全渠道数据，以One ID统一身份，构建面向业务的用户标签体系
                  </div>
                  <div class="first-word-small-item first-word-small2">
                    定义用户生命周期及识别特征，搭建完整用户画像，指导营销策略
                  </div>
                  <div class="first-word-small-item first-word-small2">
                    分渠道、分顾问、分行为查看不同分群客户转化情况，反推转化提升
                  </div>
                </div>
                <div class="min-phone-tab-img-box">
                  <img class="first-img" src="https://cdn.ideamake.cn/sw-pc/images/data-enabling-two.png" alt="">
                </div>
                <div class="first-word-big-button" @click="information('数据赋能-客户分析平台')" data-agl-cvt="5">免费试用</div>
              </div>
            </div>
            <div class="home-con-item home-con-item-big">
              <div class="first-word">
                <div class="first-word-big">
                  数据中心
                </div>
                <div class="first-word-middle">自助式的BI报表平台</div>
                <div class="first-word-small">
                  <div class="first-word-small-item first-word-small1">
                    N个多样化报表模板，营销链路多节点支撑业务决策
                  </div>
                  <div class="first-word-small-item first-word-small2">
                    灵活拖拽式操作，自由添加、管理数据，大幅降低分析难度，提高汇报沟通效率
                  </div>
                  <div class="first-word-small-item first-word-small2">
                    各类型数据自定义导出，查询结果图表化，释放分析能力
                  </div>
                </div>
                <div class="min-phone-tab-img-box">
                  <img class="first-img" src="https://cdn.ideamake.cn/sw-pc/images/data-enabling-three.png" alt="">
                </div>
                <div class="first-word-big-button" @click="information('数据赋能-数据中心')" data-agl-cvt="5">免费试用</div>
              </div>
              <div class="tab-img-box">
                <img class="first-img" src="https://cdn.ideamake.cn/sw-pc/images/data-enabling-three.png" alt="">
              </div>
            </div>
          </div>
          <input id="five" type="radio" name="tab">
          <div class="target-div">
            <div class="home-con-big-title">一站式可视化的场景营销解决方案</div>
            <div class="home-con-item home-con-item-middle">
              <div class="first-word">
                <div class="first-word-big">
                  微沙盘
                </div>
                <div class="first-word-middle">可视化场景营销利器</div>
                <div class="first-word-small">
                  <div class="first-word-small-item first-word-small1">
                    项目价值点极致演绎，满足客户看房信息需求
                  </div>
                  <div class="first-word-small-item first-word-small2">
                    一次开发，满足多场景需求，为置业顾问销讲增效
                  </div>
                  <div class="first-word-small-item first-word-small2">
                    移动端微沙盘，满足微信裂变传播，扫码分享传播
                  </div>
                  <div class="first-word-small-item first-word-small2">
                    iPad端移动案场，联动大屏、一体机，实现便捷展示
                  </div>
                </div>
                <div class="min-phone-tab-img-box">
                  <img class="first-img" src="https://cdn.ideamake.cn/sw-pc/images/visual-marketing-one.png" alt="">
                </div>
                <div class="first-word-big-button" @click="information('视觉营销-微沙盘')" data-agl-cvt="5">免费试用</div>
              </div>
              <div class="tab-img-box">
                <img class="first-img" src="https://cdn.ideamake.cn/sw-pc/images/visual-marketing-one.png" alt="">
              </div>
            </div>
            <div class="home-con-item home-con-item-big">
              <div class="tab-img-box">
                <img class="first-img" src="https://cdn.ideamake.cn/sw-pc/images/visual-marketing-two.png" alt="">
              </div>
              <div class="first-word">
                <div class="first-word-big">
                  VR带看
                </div>
                <div class="first-word-middle">在线1v1带看服务，快速跟进高质量客户</div>
                <div class="first-word-small">
                  <div class="first-word-small-item first-word-small1">
                    访客与置业顾问同屏连接，实时操控，远程讲房
                  </div>
                  <div class="first-word-small-item first-word-small2">
                    双屏交互，在线语音咨询，实时捕捉客户兴趣点
                  </div>
                  <div class="first-word-small-item first-word-small2">
                    可切换视频直播模式，实现一对一及一对多实时讲解
                  </div>
                  <div class="first-word-small-item first-word-small2">
                    轻便入口，小程序为载体在线带看
                  </div>
                </div>
                <div class="min-phone-tab-img-box">
                  <img class="first-img" src="https://cdn.ideamake.cn/sw-pc/images/visual-marketing-two.png" alt="">
                </div>
                <div class="first-word-big-button" @click="information('视觉营销-VR带看')" data-agl-cvt="5">免费试用</div>
              </div>
            </div>
            <div class="home-con-item home-con-item-big">
              <div class="first-word">
                <div class="first-word-big">
                  UE虚幻现实案场
                </div>
                <div class="first-word-middle">传统模型与数字信息的完美融合</div>
                <div class="first-word-small">
                  <div class="first-word-small-item first-word-small1">
                    城市扫描+GIS技术真实还原城市环境
                  </div>
                  <div class="first-word-small-item first-word-small2">
                    游戏级别的互动感，带给用户超越真实的场景体验
                  </div>
                  <div class="first-word-small-item first-word-small2">
                    强大跨平台功能，所有信息一键导入iPad程序
                  </div>
                </div>
                <div class="min-phone-tab-img-box">
                  <img class="first-img" src="https://cdn.ideamake.cn/sw-pc/images/visual-marketing-three.png" alt="">
                </div>
                <div class="first-word-big-button" @click="information('视觉营销-UE虚幻现实案场')" data-agl-cvt="5">免费试用</div>
              </div>
              <div class="tab-img-box">
                <img class="first-img" src="https://cdn.ideamake.cn/sw-pc/images/visual-marketing-three.png" alt="">
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
</template>
<script>
import { swTrackerClickReport } from '@/tracker.js'

export default {
    name: 'menu-Conent',
    props: {
    },
    data () {
      return {
        activeName2: 'first',
        offsetTop: 0,
        searchFixed: 0,
        offsetHeight: 0,
        offsetHeight2: 0,
        // offsetTop1: 0,
        active: 0,
        labelList: [
            {
                forName:'first',
                imgSrc: 'https://cdn.ideamake.cn/sw-pc/images/customer-acquisition-type.png',
                title: '客户获取',
            },
            {
                forName:'second',
                imgSrc: 'https://cdn.ideamake.cn/sw-pc/images/data-enabling-type.png',
                title: '客户运营',
            },
            {
                forName:'third',
                imgSrc: 'https://cdn.ideamake.cn/sw-pc/images/case-management-type.png',
                title: '案场管理',
            },
            {
                forName:'four',
                imgSrc: 'https://cdn.ideamake.cn/sw-pc/images/customer-operations-type.png',
                title: '数据赋能',
            },
            {
                forName:'five',
                imgSrc: 'https://cdn.ideamake.cn/sw-pc/images/visual-marketing-type.png',
                title: '视觉营销',
            },
        ]
      }
    },
    watch: {
      'active': {
        handler() {
          window.scrollTo({
            top: this.offsetTop-150,
            behavior: "smooth"
          })
          setTimeout(() => {
              let menuConent = this.$refs.menuConent
              this.offsetHeight2 = menuConent && menuConent.offsetHeight
            },800);
        },
        sync: true,
        immediate: true
      },
    },
    mounted () {
     
        let res = this
        this.$nextTick(() => {
            let tab = this.$refs.homeBar
            let homeBarCon = this.$refs.homeBarCon
            let menuConent = this.$refs.menuConent
            window.onresize = function(){
                res.offsetTop = homeBarCon.offsetTop;
            }
            // 吸顶元素到top的距离
            this.offsetTop = homeBarCon.offsetTop;
            this.offsetHeight = tab.offsetHeight;
            this.offsetHeight2 =  menuConent.offsetHeight
            window.addEventListener("scroll", this.throttle(this.handleScroll,200));
        });
    },
    destroyed () {
        window.removeEventListener('scroll', this.handleScroll);
        window.onresize = null;
    },
    methods: {
      changeType (i) {
        this.active = i
      },
      throttle (fn,delay) {
        let open = true;
        return function() {
          if (open == true) {
            open = false;
            setTimeout(() => {
              fn();
              open = true;
            }, delay);
          }
        };
      },
      information(pathModule) {
        swTrackerClickReport('sw_pc_free_trial', pathModule, '思为科技首页')
        this.$store.commit('doStayConsultation')
        this.$router.push({ name: 'reservation',params:{type: 1,} })
      },
      handleScroll() {
        // 得到页面滚动的距离
        let scrollTop =
          window.pageYOffset ||
          document.documentElement.scrollTop ||
          document.body.scrollTop;
        // 判断页面滚动的距离是否大于吸顶元素的位置
        // 吸顶元素到top的距离
        this.$nextTick(() => {
          this.searchFixed = (scrollTop > this.offsetTop - 180) && (scrollTop < this.offsetTop + this.offsetHeight2 - 400);
        });
      
      },
      handleClick2(tab, event) {
        console.log(tab, event);
      }
    }
}
</script>
  <style lang="scss" scoped>
.active{
    color: rgb(55, 119, 246);
    height: 88px !important;
    line-height: 88px !important;
        &::after{
            content:url('https://cdn.ideamake.cn/sw-pc/images/type.png');
            display: inline-block;
            width: 20px;
            height: 20px;
            position: absolute;
            top: -30px;
            right: -5px;
        }
        &::before{
            content: '';
            height: 3px;
            width: 196px;
            background: #3777F6;
            display: inline-block;
            vertical-align: middle;
            position: absolute;
            bottom: -1px;
            left: 0;
        }
}
.fixed{
  position: fixed;
  top: 62px;
  width: 100%;
  left: 0;
  z-index: 99;
  background: #FDFDFD;
  .home-bar-box{
    justify-content: center !important; 
  }
  box-shadow: 0px 4px 12px 0px rgba(155,165,192,0.25);
  & + #radio{
      margin-top: 170px;
  }
  & label{
    height: 62px !important;
    width: 178px !important;
    line-height: 62px !important;
    background: none !important;
    box-shadow: none !important;
    // margin-right: 126px;
    & img{
      display: none;
    }
    &::after{
      content: '';
    } 
    &::before{
      width: 58px !important;
      left: 50%;
      transform: translate(-50%);
    } 
  }
}
[type="radio"],.target-div{
    display: none;
}
:checked+.target-div{
  display: block;
}
.menuConent{
      background-color: #fff;
      .home-con{
          margin: 0 auto;
          width: 1200px;
          padding: 65px 0 100px;
          height: 718px;
          .home-bar{
            margin-bottom: 80px;
              .home-bar-box{
                display: flex;
                justify-content: space-between;
                align-items: flex-end;
              }
              & label{
                  display: inline-block;
                  width: 196px;
                  height: 80px;
                  background: linear-gradient(180deg, #F3F5F7 0%, #FFFFFF 100%);
                  box-shadow: 0px 4px 12px 0px rgba(155,165,192,0.4), inset 0px 1px 3px 0px rgba(0,0,0,0.03),;
                  border-radius: 2px;
                  border: 1.5px solid #FFFFFF;
                  cursor: pointer;
                  text-align: center;
                  line-height: 80px;
                  display: flex;
                  justify-content: center;
                  align-items: center;
                  & img{
                      width: 64px;
                      height: 70px;
                  }
                  .label-tit{
                    margin-left: 4px;
                  }
                  &:hover{
                      color:#3777F6 ;
                  }
              }
          }
          .home-con-item{
              display: flex; 
              justify-content: space-between;
              .min-phone-tab-img-box{
                display: none;
              }
              .first-word {
                  padding: 70px 0 0 20px;
                  .first-word-big{
                      color: #2D2E30;
                      font-size: 28px;
                      font-family: PingFangSC-Semibold, PingFang SC;
                      font-weight: 600;
                      margin-bottom: 12px;
                  }
                  .first-word-small{
                      font-family: PingFangSC-Regular, PingFang SC;
                      font-weight: 400;
                      color: #5A5C60;
                      font-size: 14px;
                      width: 420px;
                      .first-word-small-item{
                          margin-bottom: 8px;
                      }
                      .first-word-small1{
                          position: relative;
                          line-height: 24px;
                      }
                      .first-word-small1::before{
                          content: '';
                          display: inline-block;
                          width: 6px;
                          height: 6px;
                          border-radius: 50%;
                          background: #3777F6;
                          position: absolute;
                          left: -15px;
                          top: 8px;
                      }
                      .first-word-small2{
                          position: relative;
                          line-height: 24px;
                      }
                      .first-word-small2::before{
                          content: '';
                          display: inline-block;
                          width: 6px;
                          height: 6px;
                          border-radius: 50%;
                          background: #3777F6;
                          position: absolute;
                          left: -15px;
                          top: 8px;
                      }
                      .first-word-small3{
                          position: relative;
                          line-height: 24px;
                      }
                      .first-word-small3::before{
                          content: '';
                          display: inline-block;
                          width: 6px;
                          height: 6px;
                          border-radius: 50%;
                          background: #3777F6;
                          position: absolute;
                          left: -15px;
                          top: 8px;
                      }
                  }
              }
              .first-img{
                  width: 722px;
                  height: 448px;
              }
              .first-img1{
                  width: 712px;
                  height: 391px;
              }
          }
          .first-img-type{
              width: 64px;
              height: 70px;
              display: inline-block;
          }
        
      
          
      }
      .home-con-big{
          height: 100%;
          .home-con-item-big{
              padding-top: 127px;
          }
          .home-con-item-middle{
              padding-top: 40px;
          }
          .home-con-big-title{
              font-size: 32px;
              font-family: PingFangSC-Medium, PingFang SC;
              font-weight: 500;
              color: #2D2E30;
              text-align: center;
          }
          .first-word-middle{
              font-size: 16px;
              font-family: PingFangSC-Medium, PingFang SC;
              font-weight: 500;
              color: #2D2E30;
              margin-bottom: 25px;
          }
          .first-word-big-button{
              width: 106px;
              height: 40px;
              background: #3777F6;
              border-radius: 2px;
              font-size: 14px;
              font-family: PingFangSC-Regular, PingFang SC;
              font-weight: 400;
              color: #FFFFFF;
              line-height: 40px;
              cursor: pointer;
              text-align: center;
              margin-top: 38px;
              &:hover{
                  background: #5F92F8;
              }
          }
      }
}

// 移动端布局
@import "../min-home";
</style>
  